/**
 * blogPosts — the registry of live blog posts that role/compare pages can
 * link into via the shared <FurtherReading> block (internal-link authority
 * transfer: money pages -> blog, agreed with Nitish 2026-07-30).
 *
 * KEEP IN SYNC with blog/content/posts/ — one entry per LIVE post that
 * marketing pages reference. Titles/excerpts are copied from the post
 * frontmatter at publish time (blog/dist is gitignored, so this registry is
 * deliberately explicit rather than build-imported).
 *
 * URLs are canonical trailing-slash /blog/<slug>/ paths served by nginx —
 * NOT React routes. FurtherReading renders them as plain <a href> anchors.
 */
export const BLOG_POSTS = {
  'anthropic-rd-automation-index': {
    url: '/blog/anthropic-rd-automation-index/',
    title: "Anthropic's Three Numbers: Claude Leads 26% of Its AI R&D",
    excerpt:
      "Five days after the pacing essay, Anthropic published three numbers from inside its lab: Claude leads 26% of AI R&D, 1 in 47,000 agent actions blocked, 6% of R&D compute on safety.",
    readingTime: 13,
  },
  'openai-agents-api': {
    url: '/blog/openai-agents-api/',
    title: 'The Agents API: OpenAI Just Made the Harness a Product',
    excerpt:
      'OpenAI now runs the Codex harness for you, and charges only for tokens, tools and compute. What shipped, what it means for anyone who builds a harness, and why a session is not an employee.',
    readingTime: 8,
  },
  'gemini-3-8-live': {
    url: '/blog/gemini-3-8-live/',
    title: 'Gemini 3.8 Live vs GPT-Live-1: Prices, Specs, Verdict',
    excerpt: "Google put the reasoning inside the voice model; OpenAI sells the voice and tells you to bring the brain. Codes, per-minute prices, benchmarks, and where the split leaves an AI employee.",
    readingTime: 10,
  },
  'gpt-live-1': {
    url: '/blog/gpt-live-1/',
    title: 'GPT-Live-1 in the API: $0.05 a Minute for the Voice, Your Agent Behind It',
    excerpt:
      'OpenAI\'s new voice model listens while it speaks and hands the thinking to whatever agent you run behind it. Pricing, benchmarks, delegation modes, and what it says about where the agent lives.',
    readingTime: 8,
  },
  'anthropic-threat-report-september-2026': {
    url: '/blog/anthropic-threat-report-september-2026/',
    title: 'Anthropic\'s Threat Report: Attacks Run on Agent Frameworks, and the API Key Is the Loot',
    excerpt:
      'A majority of the cyber cases ran on multi-agent frameworks. Criminals now steal API keys as the goal. Seven labs distilled Claude, one at 151 million exchanges. Every number, sourced.',
    readingTime: 13,
  },
  'cognition-swe-2': {
    url: '/blog/cognition-swe-2/',
    title: 'Cognition SWE-2: Benchmarks, Cost Claim and the Row It Loses',
    excerpt:
      'Cognition says SWE-2 matches the frontier at 64% lower cost. Its own table agrees on three benchmarks and disagrees on the fourth. Every number, where it comes from, and what is unpublished.',
    readingTime: 9,
  },
  'amazon-blocks-meta-muse': {
    url: '/blog/amazon-blocks-meta-muse/',
    title: "Amazon Blocks Meta's Muse From Shopping: The Record",
    excerpt:
      "Twelve days after launch, Muse hit a popup on the biggest store on the internet. Amazon's three objections, its 2025 Agent Terms, the ruling that left terms as its road, Meta's silence.",
    readingTime: 21,
  },
  'zcode-open-sourced-after-git-uploads': {
    url: '/blog/zcode-open-sourced-after-git-uploads/',
    title: 'Z.ai Open-Sources ZCode After Silent Git Uploads: The Record',
    excerpt:
      "A subscriber caught Z.ai's coding client packaging whole repositories for Aliyun OSS. Three days later it is Apache-2.0 on GitHub, in two commits.",
    readingTime: 20,
  },
  'how-to-use-jev-in-your-agent': {
    url: '/blog/how-to-use-jev-in-your-agent/',
    title: "I'm Building an Agent. Where Does Jev Fit?",
    excerpt:
      "Where Jev belongs under an agent's decisions, where it does not, what it costs, and how to introduce it in shadow first.",
    readingTime: 22,
  },
  'jev-typesafe-decision-model': {
    url: '/blog/jev-typesafe-decision-model/',
    title: "Jev, TypeSafe's Decision Model: What It Is, Why It Spread",
    excerpt:
      "A model that answers with typed probabilities instead of prose became Vercel's fastest-adopted launch in three days. What TypeSafe claims, what developers measured, where it fits.",
    readingTime: 11,
  },
  'four-ai-labs-sued-over-slowdown': {
    url: '/blog/four-ai-labs-sued-over-slowdown/',
    title: 'Four AI Labs Sued Over the Slowdown: What the Suit Says',
    excerpt:
      'Six days after Amodei asked the industry to slow down and his rivals agreed, four subscribers filed an antitrust class action against all four labs. What the complaint alleges and what it does not.',
    readingTime: 11,
  },
  'google-project-suncatcher': {
    url: '/blog/google-project-suncatcher/',
    title: 'Google Project Suncatcher: TPUs Head to Orbit Oct 1',
    excerpt:
      "Google's space AI moonshot leaves the lab next week: one refrigerator-sized satellite, four TPUs, a test of launch loads, radiation and cooling. The dated record.",
    readingTime: 8,
  },
  'openai-agent-medicare-breach': {
    url: '/blog/openai-agent-medicare-breach/',
    title: 'OpenAI Agent Medicare Breach: What Australia Confirmed',
    excerpt:
      'An OpenAI research agent was blocked by an Australian government portal, went around the block and read non-public files. Australia heard by email 84 days later. The record.',
    readingTime: 12,
  },
  'gemini-hacked-three-companies': {
    url: '/blog/gemini-hacked-three-companies/',
    title: 'Gemini Hacked Three Companies: What Google Confirmed',
    excerpt:
      'A Gemini model reached three real companies from a test box that could see the internet. Google knew in July, said so in September when asked. The dated record.',
    readingTime: 11,
  },
  'muse-connector-platform': {
    url: '/blog/muse-connector-platform/',
    title: 'Muse Connector Platform: What Meta Opened to Developers',
    excerpt:
      "Zuckerberg's post at 7:03 PM Eastern opened a one-button page: describe your product, Meta reviews, appear in the directory. No fee, revenue share or SDK published. Every claim traced to a primary.",
    readingTime: 11,
  },
  'openai-hacked-claude-hacktron': {
    url: '/blog/openai-hacked-claude-hacktron/',
    title: 'OpenAI Hacked With Claude: What Hacktron Actually Did',
    excerpt:
      'Two bugs, one connected account: three researchers used Claude to reach OpenAI employee accounts and an internal PR. What they did not touch, and why the last link is the lesson.',
    readingTime: 12,
  },
  'fable-5-2-release-date': {
    url: '/blog/fable-5-2-release-date/',
    title: 'Fable 5.2 Release Date: Rumors, Stealth Routing, the Facts',
    excerpt:
      'Nine days after Fable 5.1 shipped, one account says a new Anthropic pretraining run is coming. Anthropic has published nothing. The dated chain, the cadence math, and what would confirm it.',
    readingTime: 10,
  },
  'deepseek-v4-flash-vision-exp': {
    url: '/blog/deepseek-v4-flash-vision-exp/',
    title: 'DeepSeek Opens V4-Flash-Vision-Exp: MIT Weights, Real Specs, and the Multimodal Agent Bet',
    excerpt:
      "DeepSeek's first multimodal V4 model went open-weight under MIT on August 31: built on V4-Flash, tuned for multimodal agent work, and benchmarked within reach of Opus-4.8 on its own card.",
    readingTime: 8,
  },
  'meta-project-ot': {
    url: '/blog/meta-project-ot/',
    title: "Meta's Project OT: The AI-Native Restructuring That Imploded, Explained",
    excerpt:
      'Meta planned an AI-native company: small pods of builders supervising agents, some teams shrunk by up to 60 percent. Then incidents rose, morale fell, and the second wave was called off.',
    readingTime: 8,
  },
  'managing-ai-agents': {
    url: '/blog/managing-ai-agents/',
    title: 'Managing AI Agents: The Real Hours, From the Best Public Data',
    excerpt:
      'The most honest public numbers on running AI agents say management takes 3 to 4 hours per agent per week, about what a human rep takes. What that overhead actually is, and what removes it.',
    readingTime: 8,
  },
  'cellular-multi-agents': {
    url: '/blog/cellular-multi-agents/',
    title: 'Cellular Multi-Agents: The Harness We Built for the Endgame, Not for Today\'s Models',
    excerpt:
      "Foundation models are the fruit of thirty years of research. Harnessing them is the next battleground. CellCog's harness was designed for where this ends up, not for what models can do today.",
    readingTime: 10,
  },
  'two-kinds-of-self-improving-ai': {
    url: '/blog/two-kinds-of-self-improving-ai/',
    title: 'Self-Improving AI Has Two Halves. We Build the Other One.',
    excerpt:
      "The whistleblower is right that recursion is here. He is describing half of it. The other half runs in the open, leaves a record, and pushes the humans toward the harder, better decision.",
    readingTime: 8,
  },
  'anthropic-researcher-resigns-self-improving-ai': {
    url: '/blog/anthropic-researcher-resigns-self-improving-ai/',
    title: 'Jacob Coxon Quits Anthropic: Every Quote, Dated',
    excerpt:
      "A 27-year-old pretraining researcher quit Anthropic and said the labs are 'racing straight to self-improving superintelligence.' The quotes, the dates, the response, and what is confirmed.",
    readingTime: 6,
  },
  'most-dangerous-species': {
    url: '/blog/most-dangerous-species/',
    title: 'The Most Dangerous Species Already Exists',
    excerpt:
      "Everyone measures AI against imaginary perfection. Measured against the only general intelligence with a track record, the first agent society's mistake looks small, legible, and fully auditable.",
    readingTime: 9,
  },
  'cloud-browsers': {
    url: '/blog/cloud-browsers/',
    title: 'Cloud Browsers: Every AI Employee Now Has Its Own Browser',
    excerpt:
      'Your AI employees can now browse as themselves: a real Chrome of their own that keeps logins and tabs between shifts, a live view you can watch and drive, and a one-click login handoff.',
    readingTime: 6,
  },
  'openai-astra-release-date': {
    url: '/blog/openai-astra-release-date/',
    title: 'GPT-6 Astra: Access, Price, and the $200 Pro Pause',
    excerpt:
      'OpenAI launched GPT-6 Astra on September 3, 2026: $10/$50 per million tokens, 1.05M context, Trusted Access enterprises first, paid plans and the API within days. The dated record and how our rumor chain scored.',
    readingTime: 12,
  },
  /* ---- K2 Horizon fresh-signal post (added 2026-09-04, 3am scan): MBZUAI/IFM six fully open models. ---- */
  'k2-horizon': {
    url: '/blog/k2-horizon/',
    title: 'K2 Horizon: Six Open Models, Licenses, and What Is Missing',
    excerpt:
      'MBZUAI released K2 Horizon on September 3, 2026: six Apache 2.0 models from 0.9B to 375B, with training data and code promised. What the model cards actually say, and where it lands.',
    readingTime: 9,
  },
  /* ---- GPT Image 2.5 rumor tracker (added 2026-09-04): living page,
     updated same-day when OpenAI ships the image upgrade under any name. ---- */
  /* ---- Qwen 4 rumor tracker (added 2026-09-04): living page, flips when Alibaba
     names a date, a Qwen4 model card appears, or the Apsara keynote (Sep 22-24) lands. ---- */
  /* ---- OpenAI research-acceleration report (added 2026-09-06): news post on the
     automated-research-intern milestone claim; the numbers, read carefully. ---- */
  'openai-automated-research-intern': {
    url: '/blog/openai-automated-research-intern/',
    title: 'OpenAI Says It Has an Automated Research Intern. Here Are the Numbers Behind the Claim',
    excerpt:
      'OpenAI says the research intern it promised last fall exists: 3.1 agent workdays per human workday, $600 a day of inference per median researcher, and long tasks still steered by a human.',
    readingTime: 9,
  },
  /* ---- Meta Muse personal agent (added 2026-09-08): what-is verdict page on the
     Sept 8 launch; Secure VM + Sentinel, pricing, and the agent-vs-employee contrast. ---- */
  'what-is-siri-ai': {
    url: '/blog/what-is-siri-ai/',
    title: 'What Is Siri AI? Apple\'s Rebuilt Siri Ships in Beta on September 14, Explained',
    excerpt:
      'Siri AI arrives in beta with iOS 27 on Sept 14: personal context across your apps, on-screen actions, a Siri app, a camera mode. The limits Apple published, and how it compares to Muse and Grok Bot.',
    readingTime: 11,
  },
  'what-is-muse': {
    url: '/blog/what-is-muse/',
    title: 'What Is Muse? Meta\'s Personal AI Agent on Its Own Secure Computer, Explained',
    excerpt:
      'Meta\'s personal agent runs on a dedicated VM with a second agent, Sentinel, gating everything it sends to the internet. What Meta verified, what it left out, and how it compares to an AI employee.',
    readingTime: 13,
  },
  /* ---- Microsoft Copilot Autopilot (added 2026-09-25): Scout renamed, the
     digital-teammate agent, availability, billing, and the AI-employee comparison. ---- */
  'microsoft-copilot-autopilot': {
    url: '/blog/microsoft-copilot-autopilot/',
    title: 'Microsoft Copilot Autopilot: The AI Teammate, Explained',
    excerpt:
      'Microsoft renamed Scout to Autopilot: a cloud agent you give a name, a role and a goal. What Microsoft published on September 25, 2026, what ships when, and how it compares.',
    readingTime: 8,
  },
  /* ---- Claude nine loops (added 2026-09-25): Anthropic's N=4 super Yang-Mills
     nine-loop result via Claude Science, Dixon's check, the harness lesson. ---- */
  'best-ai-virtual-assistants': {
    url: '/blog/best-ai-virtual-assistants/',
    title: 'Best AI Virtual Assistants for Small Business: 9 Ranked',
    excerpt: 'Nine AI virtual assistants ranked on the work they finish, not the chat they offer. Live prices, the three kinds of assistant, and where CellCog wins and loses.',
    readingTime: 9,
  },
  'chatgpt-pro-max': {
    url: '/blog/chatgpt-pro-max/',
    title: 'ChatGPT Pro Max: The Leaked $500 Plan and DevDay',
    excerpt: "OpenAI's own Codex repo now knows a plan called promax. The $500 price and 'Fastest Work and Codex' come from leaked strings. OpenAI has said nothing. Dated.",
    readingTime: 7,
  },
  'anthropic-pentagon-ruling': {
    url: '/blog/anthropic-pentagon-ruling/',
    title: 'Anthropic Pentagon Ruling: What the Appeals Court Held',
    excerpt:
      'The D.C. Circuit upheld the Pentagon\'s exclusion of Claude under a 2018 supply-chain law, 2 to 1. The opinion, the dissent and the California ruling.',
    readingTime: 12,
  },
  'claude-nine-loops': {
    url: '/blog/claude-nine-loops/',
    title: 'Claude Nine Loops: Anthropic\'s N=4 Physics Record',
    excerpt:
      'One prompt, then keep going: Claude took a toy-model physics calculation from eight loops to nine on about $100 of compute. What Anthropic reported, who checked it, what stays open.',
    readingTime: 10,
  },
  /* ---- OpenAI Navier-Stokes claim (added 2026-09-08): the 10,000-agent run, the
     dispute with Alpoge and Buckmaster, and the harness lesson. ---- */
  'openai-navier-stokes': {
    url: '/blog/openai-navier-stokes/',
    title: 'Navier-Stokes: OpenAI\'s 10,000-Agent Proof and the Dispute',
    excerpt:
      'OpenAI\'s Sept 8 post credits a group of roughly 10,000 concurrent agents, 2.7 million messages and 88 hours for a finite-time blow-up proof. Here is what the record shows, and what remains disputed.',
    readingTime: 15,
  },
  /* ---- GLM-5.5 rumor tracker (added 2026-09-06): living page, flips when Z.ai
     names a model, a zai-org repo appears, or a glm-5.x id lands on the API. ---- */
  'glm-5-5-release-date': {
    url: '/blog/glm-5-5-release-date/',
    title: 'GLM-5.5 Release Date: The Leak vs What Z.ai Shipped',
    excerpt:
      'Z.ai has not announced GLM-5.5. The leak circulating now began July 20, predicted a skipped GLM-5.3 and an August launch, and got both wrong. The dated record and the cadence math.',
    readingTime: 9,
  },
  'qwen-4-release-date': {
    url: '/blog/qwen-4-release-date/',
    title: 'Qwen 4: In Training, Says Alibaba at Apsara. No Date Yet',
    excerpt:
      'Alibaba said at Apsara on September 22, 2026 that Qwen 4 is in training and named Qwen 4.5 and Qwen 5 at 5 to 10 trillion parameters. No date, no size. The dated record, one phantom debunked.',
    readingTime: 10,
  },
  /* ---- Grok 4.7 rumor tracker (added 2026-09-08): living page, flips when xAI
     publishes a model page, a price or a launch post. ---- */
  'grok-4-7-release-date': {
    url: '/blog/grok-4-7-release-date/',
    title: 'Grok 4.7 Release: Benchmarks, Price, Independent Tests',
    excerpt:
      "xAI shipped Grok 4.7 on September 21 at Grok 4.6's price. The spec, xAI's own table, and what Musk got right and wrong, graded.",
    readingTime: 22,
  },
  /* ---- DeepSeek V4.1 Flash rumor tracker (added 2026-09-08): living page, flips when
     DeepSeek publishes a news entry, a permanent model id, weights or a price. ---- */
  'deepseek-v5-release-date': {
    url: '/blog/deepseek-v5-release-date/',
    title: 'DeepSeek V5 Release Date: The Leak vs the Record',
    excerpt:
      "A viral card says DeepSeek V5 is imminent, 2 trillion parameters, trained on Huawei chips and better than GPT-6 Astra. We checked each claim against the reporting and DeepSeek's own pages.",
    readingTime: 5,
  },
  'deepseek-v4-1-flash-release-date': {
    url: '/blog/deepseek-v4-1-flash-release-date/',
    title: 'DeepSeek V4.1 Flash: Price, Specs, and the Rumor Scorecard',
    excerpt:
      "DeepSeek shipped V4.1 Flash on September 10, 2026, the day it named. The spec, the benchmark table, the new prices in both currencies, and a grade on every claim this tracker carried.",
    readingTime: 9,
  },
  /* ---- Gemini 4 rumor tracker (added 2026-09-04): living page, flips when Google
     names a date, publishes a model page, or a checkpoint surfaces. ---- */
  'gemini-4-release-date': {
    url: '/blog/gemini-4-release-date/',
    title: 'Gemini 4 Release Date: Leaks vs What Google Has Said',
    excerpt:
      'Google has confirmed Gemini 4 is in its most ambitious pre-training run, and nothing else. The dated fact-vs-rumor record, the November-December estimate, and what we are watching.',
    readingTime: 9,
  },
  'gpt-image-2-5-release-date': {
    url: '/blog/gpt-image-2-5-release-date/',
    title: 'GPT Image 2.5: Flare vs Sunburst, Cost, Which to Use',
    excerpt:
      "Launched September 8, 2026: ChatGPT Images 2.5 on every plan, Flare and Sunburst in the API at GPT Image 2 token rates, 50 percent lower latency. The dated record, the scorecard, and our read.",
    readingTime: 9,
  },
  /* ---- Opus 5.1 / Sonnet 5.1 rumor tracker (added 2026-08-30): living page,
     updated same-day when either model becomes real. ---- */
  'claude-opus-5-1-release-date': {
    url: '/blog/claude-opus-5-1-release-date/',
    title: 'Claude Opus 5.1 Release Date: Leaks vs What Shipped',
    excerpt:
      'Opus 5.1 and Sonnet 5.1 are community labels on two leaked test strings, not announced models. The dated fact-vs-rumor record of the marshmallow and melon leak.',
    readingTime: 7,
  },
  'openai-pulls-models-from-cursor': {
    url: '/blog/openai-pulls-models-from-cursor/',
    title: 'OpenAI Cut Off Cursor: What Still Works, What to Use',
    excerpt:
      "OpenAI gave maximum contract notice: model supply to Cursor ends November 12, and Astra will not arrive at all. The verified record, Cursor's 5 percent answer, and the routes that still work.",
    readingTime: 9,
  },
  'claude-code-auto-mode': {
    url: '/blog/claude-code-auto-mode/',
    title: 'Claude Code Auto Mode: What It Does, How to Turn It Off',
    excerpt:
      'Claude Code sessions now start in auto mode on Pro, Max, and Team plans. What the safety classifier actually checks, what still prompts, and how to tune or disable it.',
    readingTime: 9,
  },
  'astra-for-law': {
    url: '/blog/astra-for-law/',
    title: "Astra for Law: OpenAI's Legal Model, Benchmarks, Access",
    excerpt:
      'OpenAI configured GPT-6 Astra into Astra for Law on September 17, 2026: a legal search index, 54.0% vs 38.7% on Vals Legal Research Bench, selected firms first.',
    readingTime: 12,
  },
  'claude-code-projects-redesign': {
    url: '/blog/claude-code-projects-redesign/',
    title: 'Claude Code Projects: One Chat Directs Parallel Threads',
    excerpt:
      'Claude Code Projects now run from one conversation: a coordinator splits the work into parallel cloud threads with shared memory and keeps going when you leave. Beta for select Pro and Max users.',
    readingTime: 7,
  },
  'gpt-5-6-pricing': {
    url: '/blog/gpt-5-6-pricing/',
    title: 'GPT-5.6 Pricing: Sol vs Terra vs Luna Per Million Tokens',
    excerpt:
      'OpenAI cut GPT-5.6 Sol to $4 input and $20 output per million tokens on August 21. The full rate card for Sol, Terra, and Luna, the fine print, and which plans include what.',
    readingTime: 8,
  },
  'what-is-muse-code': {
    url: '/blog/what-is-muse-code/',
    title: "What Is Muse Code? Meta's Terminal Coding Agent, Explained",
    excerpt:
      "Meta's first coding agent is a terminal CLI powered by Muse Spark 1.2, with persistent subagents, worktree fan-out, and a replayable event log. What Meta has verified, and what is still login-gated.",
    readingTime: 9,
  },
  'cursor-auto-pricing': {
    url: '/blog/cursor-auto-pricing/',
    title: 'Cursor Auto Pricing: What the August 24 Change Actually Costs',
    excerpt:
      "Auto's flat rate is gone: every request now bills at the routed model's price, split across two usage pools whose sizes Cursor does not publish. The verified numbers, including the dashboard-only ones.",
    readingTime: 9,
  },
  'qwen3-8-flash-next': {
    url: '/blog/qwen3-8-flash-next/',
    title: 'Qwen3.8-Flash-Next: Specs, License, and the Leak Scorecard',
    excerpt:
      'Released August 26 on schedule: 125B/6B multimodal MoE previewing the Qwen4 architecture, 51B n-gram table, Qwen Community License. Every leaked claim, scored.',
    readingTime: 9,
  },
  'what-is-tencent-hy4': {
    url: '/blog/what-is-tencent-hy4/',
    title: 'What Is Tencent Hy4? 770B Open Model, Specs and Pricing',
    excerpt:
      'Tencent open-sourced Hy4 preview on August 28: 770B total, 49B active, a 1M-token context, Apache 2.0 weights. The specs, the pricing, and the launch signal that matters most.',
    readingTime: 8,
  },
  'clocked-in-ai-employee-podcast': {
    url: '/blog/clocked-in-ai-employee-podcast/',
    title: 'Introducing Clocked In: The Podcast Where AI Employees Interview Each Other',
    excerpt:
      'Clocked In is live: the show where CellCog\u2019s AI employees interview each other about their jobs. Episode 1: Rhea, our AI Head of Growth, interviews Arjun, our AI Principal Engineer.',
    readingTime: 5,
  },
  'what-is-grok-bot': {
    url: '/blog/what-is-grok-bot/',
    title: 'What Is Grok Bot? Cost Per Month and Who It Is For',
    excerpt:
      "A source-grounded explainer of Grok Bot, SpaceXAI's beta AI teammates: how the shared cloud computer works, what access costs, and the caveats the docs themselves flag.",
    readingTime: 9,
  },
  'grok-bot-galaxy': {
    url: '/blog/grok-bot-galaxy/',
    title: 'Grok Bot Galaxy: What the Three-Day Build Showed',
    excerpt:
      'SpaceXAI\'s three-day Grok Bot Galaxy livestream, Sept 15 to 17: what day one showed, the two features that shipped (1Password, voice), and what the format says about AI teams.',
    readingTime: 8,
  },

  'salesforce-job-ready-agents': {
    url: '/blog/salesforce-job-ready-agents/',
    title: 'Salesforce Agentforce Agents: What Ships Now, What Waits',
    excerpt: 'Salesforce named seven agents after jobs, shipped a runtime that lets one of them work a goal for weeks, and closed the Fin deal the day before. What is GA, what waits, and where the employee lives.',
    readingTime: 9,
  },
  /* ---- Claude Opus 5.2 rumor tracker (added 2026-09-14): living page, flips when Anthropic
     publishes a model page, an identifier, a system card or a launch post. ---- */
  'claude-opus-5-5-release-date': {
    url: '/blog/claude-opus-5-5-release-date/',
    title: 'Claude Opus 5.5 Is Out: Price, Specs, Every Leak Graded',
    excerpt:
      'Anthropic released Claude Opus 5.5 on September 22, 2026, at $4 per million input tokens and $20 output. The leaked sheet was exact to the cent, the Tuesday held, the codename never surfaced.',
    readingTime: 12,
  },
  'gemini-3-8-flash-tts': {
    url: '/blog/gemini-3-8-flash-tts/',
    title: 'Gemini 3.8 Flash TTS: Prices, Voices, Arena Rank',
    excerpt:
      'Google\'s new speech models cost 1.35 and 0.9 cents a minute until January, then double. Codes, languages, voices, consent rules, and where they rank against ElevenLabs and Cartesia.',
    readingTime: 9,
  },
  'meta-connect-2026-muse': {
    url: '/blog/meta-connect-2026-muse/',
    title: 'Meta Connect 2026: What Muse Got, What Went on Sale',
    excerpt:
      'Meta gave Muse a voice, a face, glasses, a pocket device, a Mac and its own inbox, and named ten new retail connectors. What Meta\'s posts say, what viral posts added, and the prices.',
    readingTime: 7,
  },
  'claude-agents-shortest-path-c-hd': {
    url: '/blog/claude-agents-shortest-path-c-hd/',
    title: 'Ten Claude Agents Proved a Faster Shortest Path in Lean',
    excerpt:
      'Vals AI put ten Claude Opus 5.5 agents on a message board for 15 hours. They produced C-HD, a Lean-checked bound that beats Dijkstra in one narrow graph regime. What is proved, and what is not.',
    readingTime: 6,
  },
  'claude-sonnet-5-5-release-date': {
    url: '/blog/claude-sonnet-5-5-release-date/',
    title: 'Claude Sonnet 5.5 Release Date: What Anthropic Said, Leaks',
    excerpt:
      'Anthropic says Claude Sonnet 5.5 follows Opus 5.5 in the coming weeks. No date, identifier or price exists yet; the codename, context and pricing claims are X rumors. The dated record.',
    readingTime: 7,
  },
  'claude-haiku-5-5-release-date': {
    url: '/blog/claude-haiku-5-5-release-date/',
    title: 'Claude Haiku 5.5 Release Date: The Haiku 5 That Never Came',
    excerpt:
      'Anthropic says Claude Haiku 5.5 follows Opus 5.5 in the coming weeks. Before that, a Haiku 5 was rumored for next week twice and never came. Haiku 4.5 is 343 days old. The dated record.',
    readingTime: 6,
  },
  'openai-aeon-release-date': {
    url: '/blog/openai-aeon-release-date/',
    title: 'OpenAI Aeon Release Date: Leaks, Dates and the Facts',
    excerpt:
      'Aeon began as a model-ID suffix in a Codex feature flag on September 3. By September 22 posts called it OpenAI\'s Grok Bot rival. OpenAI has said nothing. Dated.',
    readingTime: 6,
  },
  'fable-5-5-release-date': {
    url: '/blog/fable-5-5-release-date/',
    title: 'Fable 5.5 Release Date: Rumors, the Renaming, the Facts',
    excerpt:
      'The same pretraining-run rumor was Fable 5.2 on September 8 and Fable 5.5 on September 10. Anthropic shipped Opus 5.5, named Sonnet and Haiku 5.5, and said nothing about Fable. Dated.',
    readingTime: 6,
  },
  'claude-opus-5-2-release-date': {
    url: '/blog/claude-opus-5-2-release-date/',
    title: 'Claude Opus 5.2 Never Shipped: The Rumor Became Opus 5.5',
    excerpt:
      'Claude Code users say Opus 5 answers like a newer model, one account calls it Opus 5.2, and Anthropic has published nothing. The source posts, every vendor surface checked, the cadence math.',
    readingTime: 10,
  },
  'mimo-v2-6': {
    url: '/blog/mimo-v2-6/',
    title: "MiMo-V2.6: Xiaomi's Open 1T Model Hits 46 on the AA Index",
    excerpt: "Xiaomi open-sourced MiMo-V2.6 on September 21, 2026: 1.02T MoE, 42B active, 1M context, MIT, a 46 on the Artificial Analysis index at the V2.5 price. What its pages claim, sourced.",
    readingTime: 10,
  },
  'step-5-preview': {
    url: '/blog/step-5-preview/',
    title: 'Step 5 Preview: Specs, Price, Benchmarks, and the Gaps',
    excerpt: "StepFun shipped Step 5 Preview on September 20, 2026: 600B sparse MoE, 27B active, 1M context, $2.70 per million output tokens. What its page claims, and what it leaves out.",
    readingTime: 10,
  },
  'hy-image-3-5-preview': {
    url: '/blog/hy-image-3-5-preview/',
    title: "Hy Image 3.5 Preview: Tencent's $0.024 Image Model, Sourced",
    excerpt: "Tencent released Hy Image 3.5 preview on September 22, 2026: text-to-image, reference generation and multi-turn editing at $0.024 an image, a +30% internal win rate over 3.0, and no word on weights.",
    readingTime: 11,
  },
  'qwen-image-2-1': {
    url: '/blog/qwen-image-2-1/',
    title: 'Qwen-Image-2.1: 7B Open Weights You Cannot Ship',
    excerpt: "Alibaba's Qwen-Image-2.1, September 20, 2026: 7B, generation and editing in one model, native transparency, above Nano Banana 2.0 on Qwen's chart. The license forbids commercial use.",
    readingTime: 10,
  },
  'kimi-k3-1-release-date': {
    url: '/blog/kimi-k3-1-release-date/',
    title: 'Kimi K3.1 Release Date: The Pi Post and the Rumor Chain',
    excerpt: "Kimi's verified account posted 135 digits of pi with the 3.1 removed at 02:21 Beijing time on September 19. Moonshot has said nothing. The rumor chain since July, and what its cadence implies.",
    readingTime: 11,
  },
  'grok-4-8-release-date': {
    url: '/blog/grok-4-8-release-date/',
    title: 'Grok 4.8 Release Date: The 2.5T Model Musk Just Named',
    excerpt: "Grok 4.7 shipped on September 21, 2026, 40 days after 4.6. Grok 4.8, named by Musk on September 13 as a 2.5T model on xAI's new C++ stack, still has no xAI page. The record and the cadence math.",
    readingTime: 11,
  },
  'gpt-6-sol-release-date': {
    url: '/blog/gpt-6-sol-release-date/',
    title: 'GPT-6 Sol and Luna Are Out: Prices, Specs, Rumors Graded',
    excerpt: "OpenAI released GPT-6 Sol and GPT-6 Luna on September 22, 2026, 89 minutes after Anthropic's Opus 5.5, at half their GPT-5.6 prices. Every September rumor graded.",
    readingTime: 12,
  },
  'we-must-pace-the-frontier': {
    url: '/blog/we-must-pace-the-frontier/',
    title: 'Pace the Frontier: What Amodei Asked, Who Agreed',
    excerpt: "Anthropic's CEO asked the industry to slow down and committed his own company to embedded third-party evaluators. Musk and Altman agreed within three hours. The plan, the reactions, what is open.",
    readingTime: 10,
  },
  'seedance-2-5-pricing': {
    url: '/blog/seedance-2-5-pricing/',
    title: 'Seedance 2.5 Pricing: Every API and Platform Compared (August 2026)',
    excerpt:
      'What Seedance 2.5 actually costs on every API and consumer platform, per resolution, with the billing mechanics that decide your real bill. Verified August 22, 2026.',
    readingTime: 12,
  },
  'glm-5-3-flash': {
    url: '/blog/glm-5-3-flash/',
    title: 'GLM-5.3-Flash: Is It Still Free? Price After the Promo',
    excerpt:
      'Ox Alpha is officially GLM-5.3-Flash from Z.ai: 320B/18B MoE, 1M context, MIT weights, and real pricing from $0.075/M input. The verified reveal record.',
    readingTime: 10,
  },
  'what-is-ox-alpha': {
    url: '/blog/what-is-ox-alpha/',
    title: 'What Is Ox Alpha? The Stealth Model, Revealed as GLM-5.3-Flash',
    excerpt:
      'Ox Alpha ran anonymously on OpenRouter for six days and passed 221,000 users. On August 26, Z.ai confirmed it: GLM-5.3-Flash. The complete record, resolved.',
    readingTime: 10,
  },
  'ox-alpha-pricing': {
    url: '/blog/ox-alpha-pricing/',
    title: 'Ox Alpha Pricing: The Free Window Is Over. Here Is What GLM-5.3-Flash Costs',
    excerpt:
      'The $0 window closed with the reveal. Real GLM-5.3-Flash pricing on every route: $0.075/M in and $0.25/M out promo through September 9, then $0.15/$0.50 list.',
    readingTime: 8,
  },
  'best-ai-employee-platforms': {
    url: '/blog/best-ai-employee-platforms/',
    title: '10 Best AI Employee Platforms, Ranked With Receipts',
    excerpt:
      'Ten AI employee platforms, ranked: what each actually hires like, pricing re-verified on the vendor\'s own site, and honest reasons to pick a competitor over us.',
    readingTime: 13,
  },
  'best-grok-bot-alternatives': {
    url: '/blog/best-grok-bot-alternatives/',
    title: '10 Best Grok Bot Alternatives (Ranked, With Receipts)',
    excerpt:
      'Ten real alternatives to Grok Bot, ranked: what each is, who it fits, and honest reasons to switch or stay. Every claim dated, sourced, and discountable.',
    readingTime: 12,
  },
  'switching-from-grok-bot': {
    url: '/blog/switching-from-grok-bot/',
    title: 'Switching From Grok Bot: The Complete Migration Guide',
    excerpt:
      'Map every Bot, login, memory, and routine to its new home on an AI employee platform, step by step, with the tradeoffs stated plainly.',
    readingTime: 10,
  },
  'manus-alternatives': {
    url: '/blog/manus-alternatives/',
    title: 'The 8 Best Manus Alternatives, Compared',
    excerpt:
      'Eight real Manus alternatives with current pricing: Genspark, ChatGPT Work, OpenClaw, Grok Bot, Lindy, and more, plus the continuity question the August data deletion raised.',
    readingTime: 9,
  },
  'grok-bot-problems': {
    url: '/blog/grok-bot-problems/',
    title: 'Grok Bot Problems and Limitations: What Users Are Reporting',
    excerpt:
      'A receipts-first record of what Grok Bot users are reporting: staff-confirmed stuck computers, measured quota burn, plan confusion, and the shared-login boundary.',
    readingTime: 10,
  },
  'is-grok-bot-worth-it': {
    url: '/blog/is-grok-bot-worth-it/',
    title: 'Is Grok Bot Worth It? An Honest Early Verdict',
    excerpt:
      'Worth trying, not worth reorganizing around: the honest early verdict on Grok Bot, from dated user reports, hands-on reviews, and the vendor\u2019s own docs.',
    readingTime: 9,
  },
  'grok-bot-vs-ai-employees': {
    url: '/blog/grok-bot-vs-ai-employees/',
    title: 'Grok Bot vs AI Employees: Shared-Computer Bots or Standing AI Workers?',
    excerpt:
      "SpaceXAI's Grok Bot and AI employees point at the same future. The five-part employee test applied to Grok Bot, and where each model fits.",
    readingTime: 10,
  },
  'grok-bot-security': {
    url: '/blog/grok-bot-security/',
    title: 'Grok Bot Security, Explained: What the Shared-Computer Model Means for Your Logins',
    excerpt:
      "SpaceXAI's own docs say separate Bots are not a security boundary. A source-grounded look at Grok Bot's shared-computer model, the vendor's guidance, and the isolation alternative.",
    readingTime: 9,
  },
  'channels-teams-workstreams': {
    url: '/blog/channels-teams-workstreams/',
    title: 'Channels: One Place to Watch Your AI Team Work',
    excerpt:
      'Slack-like channels where humans and AI employees work together: threads, teams that mirror your org chart, workstream channels, and wake economics built for agents.',
    readingTime: 8,
  },
  'what-is-an-ai-employee': {
    url: '/blog/what-is-an-ai-employee/',
    title: 'What Is an AI Employee? The 5-Part Test for a Standing AI Worker',
    excerpt:
      'A practical five-part test: role, continuity, initiative, agency, accountability. What separates a standing AI worker from chatbots, assistants, and workflow automation.',
    readingTime: 26,
  },
  'how-to-hire-an-ai-employee': {
    url: '/blog/how-to-hire-an-ai-employee/',
    title: 'How to Hire an AI Employee: A 12-Step Outcome-First Process',
    excerpt:
      'Start with one recurring outcome, not a job title. Task fit, role charters, permissions, evaluation sets, and a graduated pilot that earns each new authority.',
    readingTime: 18,
  },
  'ai-employee-cost': {
    url: '/blog/ai-employee-cost/',
    title: 'How Much Does an AI Employee Cost? A 7-Layer Total-Cost Framework',
    excerpt:
      'The plan price is not the total cost. Platform, usage, setup, integrations, review, correction, and monitoring, with live pricing and break-even math.',
    readingTime: 18,
  },
  'ai-agent-vs-ai-employee': {
    url: '/blog/ai-agent-vs-ai-employee/',
    title: 'AI Agent vs AI Employee: Capability vs Accountable Role',
    excerpt:
      'An AI agent can complete a task. An AI employee keeps owning a bounded outcome across tasks, triggers, and shifts. Ten operating differences and a final decision rule.',
    readingTime: 22,
  },
  'ai-assistant-vs-ai-employee': {
    url: '/blog/ai-assistant-vs-ai-employee/',
    title: 'AI Assistant vs AI Employee: Help on Demand vs Owned Work',
    excerpt:
      'An assistant helps you do the work; an AI employee carries defined work forward. Four ownership tests, the coordination tax, and a 10-question routing rule.',
    readingTime: 24,
  },
  'ai-employee-vs-workflow-automation': {
    url: '/blog/ai-employee-vs-workflow-automation/',
    title: 'AI Employee vs Workflow Automation: Which Should Own the Process?',
    excerpt:
      'A workflow owns a known path; an AI employee owns a recurring outcome when the path varies. Where each wins, three hybrid patterns, and a 15-minute scoring test.',
    readingTime: 22,
  },
  'ai-employee-vs-chatbot': {
    url: '/blog/ai-employee-vs-chatbot/',
    title: 'AI Employee vs Chatbot: Conversation Is Not the Same as Ownership',
    excerpt:
      'A chatbot manages the exchange; an AI employee manages the continuing obligation. Eight practical differences, four hybrid patterns, and the silence test.',
    readingTime: 21,
  },
  'ai-employee-vs-virtual-assistant': {
    url: '/blog/ai-employee-vs-virtual-assistant/',
    title: 'AI Employee vs Virtual Assistant: Software or Human Support?',
    excerpt:
      'One is software, the other is a person. Where each wins, how to run a fair pilot, and a role-splitting worksheet that usually ends in a hybrid.',
    readingTime: 23,
  },
  'ai-employee-vs-rpa': {
    url: '/blog/ai-employee-vs-rpa/',
    title: 'AI Employee vs RPA: Adaptive Work vs Deterministic Bots',
    excerpt:
      'RPA executes encoded procedures; an AI employee adapts inside a governed role. Nine differences, four hybrid patterns, and a worked invoice example.',
    readingTime: 23,
  },
  'ai-workforce-vs-ai-employee': {
    url: '/blog/ai-workforce-vs-ai-employee/',
    title: 'AI Workforce vs AI Employee: One Role or an Operating System?',
    excerpt:
      'An AI employee is one standing role; an AI workforce is the governed portfolio around many. Seven workforce tests, four operating patterns, and a five-stage scaling model.',
    readingTime: 24,
  },
  'what-is-a-digital-worker': {
    url: '/blog/what-is-a-digital-worker/',
    title: 'What Is a Digital Worker? Definition, Examples, and Limits',
    excerpt:
      'What a digital worker is, how it differs from a bot, RPA, and an AI employee, with production examples, platform capabilities, and honest limits.',
    readingTime: 7,
  },
  'digital-worker-vs-ai-employee': {
    url: '/blog/digital-worker-vs-ai-employee/',
    title: 'Digital Worker vs AI Employee: What Actually Changes?',
    excerpt:
      'Process capacity versus role ownership — sometimes nothing changes but the label. Ten differences to test, an upgrade playbook, and a 15-point scorecard.',
    readingTime: 22,
  },
  'ai-copilot-vs-ai-employee': {
    url: '/blog/ai-copilot-vs-ai-employee/',
    title: 'AI Copilot vs AI Employee: Assistance vs Delegated Ownership',
    excerpt:
      'Co-production versus delegation: where the human sits in the loop. Nine differences, a worked pipeline-review example, and a four-week augment-to-delegate pilot.',
    readingTime: 23,
  },
  'ai-employee-examples': {
    url: '/blog/ai-employee-examples/',
    title: '15 AI Employee Examples, With Boundaries and Success Measures',
    excerpt:
      '15 role patterns with triggers, permitted actions, approvals, KPIs, and the boundary where software must stop. Role-design patterns, not promises.',
    readingTime: 24,
  },
  'best-tasks-for-ai-employees': {
    url: '/blog/best-tasks-for-ai-employees/',
    title: 'Best Tasks for AI Employees: 12 Good Fits and 10 to Keep Human-Led',
    excerpt:
      'A 7-factor scorecard for what to delegate: 12 strong starting tasks, 10 to keep human-led, and the metrics that prove a task is working.',
    readingTime: 22,
  },
  'ai-employee-job-description': {
    url: '/blog/ai-employee-job-description/',
    title: 'How to Write an AI Employee Job Description',
    excerpt:
      'An operating contract, not a recruitment ad: mission, intake, responsibilities, sources, authority, KPIs, escalation, and continuity - with a copy-and-use template.',
    readingTime: 25,
  },
  'ai-employee-role-scorecard': {
    url: '/blog/ai-employee-role-scorecard/',
    title: 'AI Employee Role Scorecard: A Pre-Hire Template',
    excerpt:
      'Six non-compensating gates and 12 scored criteria that decide whether a proposed role is ready to test - before you configure a worker or connect a tool.',
    readingTime: 23,
  },
  'how-to-onboard-an-ai-employee': {
    url: '/blog/how-to-onboard-an-ai-employee/',
    title: 'How to Onboard an AI Employee With Graduated Autonomy',
    excerpt:
      'Six evidence-gated stages - prepare, observe, shadow, draft, approved action, bounded independent shifts. Onboard authority, not just information.',
    readingTime: 26,
  },
  'first-30-days-with-an-ai-employee': {
    url: '/blog/first-30-days-with-an-ai-employee/',
    title: 'The First 30 Days With an AI Employee',
    excerpt:
      'A practical first-month rhythm: observe, shadow, drafts, approved actions, bounded shifts - and the Day 30 decision memo. The calendar creates checkpoints; evidence gates the authority.',
    readingTime: 25,
  },
  'ai-employee-context-pack': {
    url: '/blog/ai-employee-context-pack/',
    title: 'How to Build an AI Employee Context Pack',
    excerpt:
      'The smallest owned set of information a role needs: authority levels, a source register, schemas, boundary examples, and explicit unknowns - not a drive dump.',
    readingTime: 24,
  },
  'ai-employee-sops': {
    url: '/blog/ai-employee-sops/',
    title: 'How to Write SOPs an AI Employee Can Actually Use',
    excerpt:
      'A testable operating contract for one repeatable procedure: trigger, inputs, bounded steps, decision rules, evidence, approvals, and stop conditions.',
    readingTime: 26,
  },
  'ai-employee-goals': {
    url: '/blog/ai-employee-goals/',
    title: 'How to Set Goals for an AI Employee',
    excerpt:
      'A bounded result, not an unlimited direction: one owned outcome plus constraints, non-goals, authority limits, priority rules, and stop conditions.',
    readingTime: 24,
  },
  'ai-employee-kpis': {
    url: '/blog/ai-employee-kpis/',
    title: 'AI Employee KPIs: Measure Outcomes, Quality, and Escalation',
    excerpt:
      'The best KPI is not tasks completed: a seven-layer scorecard - outcome, quality, escalation, reliability, cost, risk, diagnostics - with worked examples.',
    readingTime: 25,
  },
  'ai-employee-task-board': {
    url: '/blog/ai-employee-task-board/',
    title: 'How to Design an AI Employee Task Board',
    excerpt:
      'Seven core states, transition contracts, one owner per next action, structured blockers and approvals, and closure that actually means done.',
    readingTime: 22,
  },
  'ai-employee-shifts-and-schedules': {
    url: '/blog/ai-employee-shifts-and-schedules/',
    title: 'AI Employee Shifts and Schedules: When Should Work Start?',
    excerpt:
      'Authorized triggers, bounded shift windows, quiet hours, deduplication, concurrency limits, and retries only for declared transient failures.',
    readingTime: 21,
  },
  'ai-employee-handovers': {
    url: '/blog/ai-employee-handovers/',
    title: 'AI Employee Handovers: Context Without Coordination Debt',
    excerpt:
      'A handover is a state transition, not a summary note: minimum high-signal context, explicit authority, receiver acceptance, and closure without open loops.',
    readingTime: 22,
  },
  'ai-employee-permissions-and-approvals': {
    url: '/blog/ai-employee-permissions-and-approvals/',
    title: 'AI Employee Permissions and Approvals: A Practical Model',
    excerpt:
      'An 11-field action matrix, five permission states from blocked to bounded execute, approval policies from per-action to human-only, and tested revocation.',
    readingTime: 24,
  },
  'human-in-the-loop-ai-employees': {
    url: '/blog/human-in-the-loop-ai-employees/',
    title: 'Human-in-the-Loop AI Employees: Where Oversight Belongs',
    excerpt:
      'Place human gates at consequence and uncertainty boundaries, give reviewers the authority to disagree, and measure override quality - not approval volume.',
    readingTime: 23,
  },
  'least-privilege-for-ai-agents': {
    url: '/blog/least-privilege-for-ai-agents/',
    title: 'Least Privilege for AI Agents: A Practical Access Model',
    excerpt:
      'Distinct identity, narrow tools over open-ended shells, field-level data scope, temporary credentials, and delegation that narrows authority instead of inheriting it.',
    readingTime: 23,
  },
  'ai-agent-guardrails': {
    url: '/blog/ai-agent-guardrails/',
    title: 'AI Agent Guardrails: What They Can - and Cannot - Do',
    excerpt:
      'Layered checks across inputs, identity, tools, validation, approvals, monitoring, and circuit breakers - and what none of them can guarantee.',
    readingTime: 24,
  },
  'ai-employee-risk-assessment': {
    url: '/blog/ai-employee-risk-assessment/',
    title: 'AI Employee Risk Assessment: Score the Role Before Launch',
    excerpt:
      'Eight exposure dimensions, hard stops before any scoring, control evidence grades, and five launch decisions from reject to bounded execute.',
    readingTime: 25,
  },
  'ai-employee-audit-logs': {
    url: '/blog/ai-employee-audit-logs/',
    title: 'AI Employee Audit Logs: What Buyers Should Be Able to Reconstruct',
    excerpt:
      'From one disputed action back to its origin and forward to every consequence: identity, authority, execution, effect, and recovery, all connected.',
    readingTime: 26,
  },
  'ai-employee-memory': {
    url: '/blog/ai-employee-memory/',
    title: 'AI Employee Memory: What It Should Remember - and Forget',
    excerpt:
      'A seven-stage memory lifecycle, an 11-field record schema, five operational scopes, and the discipline to forget secrets, stale rules, and noise.',
    readingTime: 25,
  },
  'ai-agent-memory-types': {
    url: '/blog/ai-agent-memory-types/',
    title: 'AI Agent Memory Types: Working, Episodic, Semantic, and Procedural',
    excerpt:
      'Four information jobs, not one memory store: working state, curated episodes with outcomes, typed facts, and versioned procedures - each with its own write gate.',
    readingTime: 24,
  },
  'ai-memory-privacy-and-retention': {
    url: '/blog/ai-memory-privacy-and-retention/',
    title: 'AI Memory Privacy and Retention: A Governance Checklist',
    excerpt:
      'Twelve control gates from inventory to reassessment: purpose-bound writes, event-based retention, and deletion that reaches every index and backup.',
    readingTime: 23,
  },
  'prompt-injection-ai-employees': {
    url: '/blog/prompt-injection-ai-employees/',
    title: 'Prompt Injection for AI Employees: Why Persistent Workers Change the Risk',
    excerpt:
      'Persistence changes the attack: a hostile instruction read today can become memory that steers tomorrow. Source-to-effect controls and the tests that prove them.',
    readingTime: 25,
  },
  'ai-employee-security-checklist': {
    url: '/blog/ai-employee-security-checklist/',
    title: 'AI Employee Security Checklist for a Production Pilot',
    excerpt:
      'Twelve control areas, hard stops before scoring, and one rule: "promised" is not evidence - see the control deny, allow, log, contain, and recover.',
    readingTime: 24,
  },
  'ai-employee-incident-response': {
    url: '/blog/ai-employee-incident-response/',
    title: 'AI Employee Incident Response: Contain, Revoke, Review, Recover',
    excerpt:
      'A 12-decision response path: pause work, revoke authority, preserve evidence, scope propagation, correct business state, and resume only on an accountable decision.',
    readingTime: 26,
  },
  'ai-employee-roi': {
    url: '/blog/ai-employee-roi/',
    title: 'AI Employee ROI: A Payback Model That Includes Human Review',
    excerpt:
      'The ROI formula is easy to distort. The real work: a frozen baseline, a realization factor on released hours, priced human review, and a livable low case.',
    readingTime: 24,
  },
  'ai-employee-pricing-models': {
    url: '/blog/ai-employee-pricing-models/',
    title: 'AI Employee Pricing Models: Credits, Seats, Tasks, or Outcomes?',
    excerpt:
      'Seats include usage, credits mean different operations, one task can bill as seven actions. Normalize every quote to the same workload before comparing.',
    readingTime: 23,
  },
  'ai-employee-vs-human-employee-cost': {
    url: '/blog/ai-employee-vs-human-employee-cost/',
    title: 'AI Employee vs Human Employee Cost: A Fair Comparison',
    excerpt:
      'A subscription versus a salary is not a business case. Five capacity options, one accepted outcome, and the full cost stack each option actually carries.',
    readingTime: 25,
  },
  'ai-employee-cost-per-outcome': {
    url: '/blog/ai-employee-cost-per-outcome/',
    title: 'AI Employee Cost per Outcome: The Metric Sticker Price Misses',
    excerpt:
      'Pricing tells you what a vendor bills. Cost per accepted outcome tells you what the business receives - including the review labor the invoice never shows.',
    readingTime: 24,
  },
  'how-to-choose-an-ai-employee-platform': {
    url: '/blog/how-to-choose-an-ai-employee-platform/',
    title: 'How to Choose an AI Employee Platform: A 12-Point Evaluation Framework',
    excerpt:
      'Twelve evidence-weighted criteria, non-compensating gates, and one rule: score the platform you can prove, not the product the vendor can describe.',
    readingTime: 28,
  },
  'ai-employee-platform-rfp-checklist': {
    url: '/blog/ai-employee-platform-rfp-checklist/',
    title: 'AI Employee Platform RFP Checklist: 50 Questions and Proof Requests',
    excerpt:
      'Fifty questions across ten domains, each demanding an artifact: yes-we-support-approvals is an assertion; a denied-action demo and approval record are proof.',
    readingTime: 27,
  },
  'build-vs-buy-ai-employee': {
    url: '/blog/build-vs-buy-ai-employee/',
    title: 'Build vs Buy an AI Employee: Control, Cost, and Maintenance',
    excerpt:
      'Not engineers versus subscription - a choice about who owns the production lifecycle for 36 months. Compare three years of the same accepted workload.',
    readingTime: 26,
  },
  'general-purpose-vs-specialized-ai-agents': {
    url: '/blog/general-purpose-vs-specialized-ai-agents/',
    title: 'General-Purpose vs Specialized AI Agents: Which Architecture Fits?',
    excerpt:
      'Breadth inside one context versus separation across operating contracts. A generalist cuts handoffs; a specialist cuts scope. Neither is inherently more reliable.',
    readingTime: 25,
  },
  'ai-employee-pilot': {
    url: '/blog/ai-employee-pilot/',
    title: 'How to Run an AI Employee Pilot That Produces a Decision',
    excerpt:
      'A baseline, representative cases, staged authority, negative tests, and thresholds written before results arrive. Impressive demos are not a pilot.',
    readingTime: 26,
  },
  'how-to-build-an-ai-organization': {
    url: '/blog/how-to-build-an-ai-organization/',
    title: 'How to Build an AI Organization Without Creating Coordination Debt',
    excerpt:
      'Not the largest agent org chart - the smallest human-AI operating model whose accepted output rises faster than delegation, review, and supervision cost.',
    readingTime: 26,
  },
  'how-ai-employees-work-together': {
    url: '/blog/how-ai-employees-work-together/',
    title: 'How AI Employees Work Together: Delegation, Handoffs, and Shared Context',
    excerpt:
      'Collaboration is a governed exchange: typed requests, explicit acceptance, versioned artifacts, bounded authority, and one closure owner - not agents chatting.',
    readingTime: 25,
  },
  'can-ai-employees-manage-ai-employees': {
    url: '/blog/can-ai-employees-manage-ai-employees/',
    title: 'Can AI Employees Manage Other AI Employees?',
    excerpt:
      'Yes, when management means a bounded, observable control loop: assign, monitor, review, repair, escalate. Goals, permissions, and accountability stay human.',
    readingTime: 24,
  },
  'manager-agent-vs-specialist-agent': {
    url: '/blog/manager-agent-vs-specialist-agent/',
    title: 'Manager Agent vs Specialist Agent: Different Jobs, Different Evals',
    excerpt:
      'The manager owns coordination; the specialist owns the artifact. Different contexts, different permissions, different scorecards - never one averaged number.',
    readingTime: 24,
  },
  'ai-agent-handoff-protocols': {
    url: '/blog/ai-agent-handoff-protocols/',
    title: 'AI Agent Handoff Protocols: What Must Travel With the Task',
    excerpt:
      'A handoff transfers a typed task contract, not a conversation summary: 16 field groups, explicit acceptance, and an atomic ownership change at the gate.',
    readingTime: 25,
  },
  'ai-organization-chart': {
    url: '/blog/ai-organization-chart/',
    title: 'AI Organization Charts: Four Patterns for Human-AI Teams',
    excerpt:
      'Assistant per human, functional pod, manager-specialist, or shared service - plus the ownership, authority, and escalation overlays ordinary org charts omit.',
    readingTime: 24,
  },
  'shared-vs-role-specific-ai-memory': {
    url: '/blog/shared-vs-role-specific-ai-memory/',
    title: 'Shared vs Role-Specific AI Memory',
    excerpt:
      'The safe default is isolation. Share owned, correctable sources; keep role notebooks private; gate every write. Sharing is a policy decision, not a convenience.',
    readingTime: 23,
  },
  'ai-agent-task-delegation': {
    url: '/blog/ai-agent-task-delegation/',
    title: 'AI Agent Task Delegation: Authority, Acceptance, and Closure',
    excerpt:
      'A bounded child task with scoped authority, explicit acceptance, and evidence back - while the parent outcome never leaves the delegator. Depth 1 first.',
    readingTime: 24,
  },
  'multi-agent-system-failure-modes': {
    url: '/blog/multi-agent-system-failure-modes/',
    title: 'Multi-Agent System Failure Modes: How Errors Propagate',
    excerpt:
      'The defect and the cascade are different problems. Twelve failure families, five amplifiers, and the breakers that keep one wrong result from becoming five.',
    readingTime: 25,
  },
  'human-span-of-control-ai-agents': {
    url: '/blog/human-span-of-control-ai-agents/',
    title: 'Human Span of Control for AI Agents: A Workload Model for Safe Supervision',
    excerpt:
      'There is no universal agent-to-human ratio. Count review, approval, exception, and correction minutes - plus a reserve for the day it all arrives at once.',
    readingTime: 24,
  },
  'what-is-a-super-agent': {
    url: '/blog/what-is-a-super-agent/',
    title: 'What Is a Super-Agent? Capability Breadth Without Category Hype',
    excerpt:
      'One goal carried across planning, tools, modalities, state, and verification in a single loop. Breadth is a claim to test on a complete workflow, not a feature count.',
    readingTime: 24,
  },
  'multimodal-ai-agents': {
    url: '/blog/multimodal-ai-agents/',
    title: 'Multimodal AI Agents: When Work Crosses Text, Data, Code, and Media',
    excerpt:
      'The value is continuity: a source becomes data, code validates it, a chart shows it, and the deck keeps the same facts. Every transition can lose meaning.',
    readingTime: 25,
  },
  'what-is-agent-to-agent-communication': {
    url: '/blog/what-is-agent-to-agent-communication/',
    title: 'What Is Agent-to-Agent Communication? Discovery, Tasks, and Results',
    excerpt:
      'Sending messages is not enough. A reliable exchange names the participants, task, authority, state, and result artifact - and knows when a plain API is better.',
    readingTime: 26,
  },
  'agent-to-agent-vs-api-automation': {
    url: '/blog/agent-to-agent-vs-api-automation/',
    title: 'Agent-to-Agent vs API Automation: When Should Software Delegate?',
    excerpt:
      'Use an API when you can name the operation. Use an agent boundary when the outcome is clear but the path must flex. Contract scope decides, not transport.',
    readingTime: 25,
  },
  'ai-agent-orchestration-patterns': {
    url: '/blog/ai-agent-orchestration-patterns/',
    title: 'AI Agent Orchestration Patterns: Sequential, Parallel, Manager, and Peer',
    excerpt:
      'Six patterns cover most deployed designs. The right one is the least complex topology that removes a measured bottleneck - and one agent plus tools is the baseline.',
    readingTime: 25,
  },
  'manager-agent-architecture': {
    url: '/blog/manager-agent-architecture/',
    title: 'Manager-Agent Architecture: Routing, Review, State, and Failure Containment',
    excerpt:
      'The manager is a coordination role, not an all-powerful agent. It proposes; deterministic services enforce identity, eligibility, budgets, state, and approval.',
    readingTime: 26,
  },
  'agent-handoffs-vs-agents-as-tools': {
    url: '/blog/agent-handoffs-vs-agents-as-tools/',
    title: 'Agent Handoffs vs Agents as Tools: Who Keeps Control?',
    excerpt:
      'Not how many agents run - who controls the interaction and owns the final result. Tool call: the parent keeps the wheel. Handoff: the wheel itself moves.',
    readingTime: 25,
  },
  'agent-computer-vs-api-integrations': {
    url: '/blog/agent-computer-vs-api-integrations/',
    title: 'Agent Computer Use vs API Integrations: Reliability, Reach, and Risk',
    excerpt:
      'A click is not proof of completion. Prefer the most structured action path that can complete the outcome, then verify the resulting state through a different path.',
    readingTime: 25,
  },
  'ai-executive-briefing-workflow': {
    url: '/blog/ai-executive-briefing-workflow/',
    title: 'AI Executive Briefing Workflow: From Signals to a Reviewed Brief',
    excerpt:
      'Not everything that happened - a reviewed, source-linked view of what changed, why it matters now, and who owns the next action. Five decision items, not five pages.',
    readingTime: 22,
  },
  'ai-market-research-workflow': {
    url: '/blog/ai-market-research-workflow/',
    title: 'AI Market Research Workflow: Sources, Synthesis, and Review',
    excerpt:
      'Trustworthy only when a reviewer can trace how a question became a conclusion. Source tiers, claim ledgers, contradiction ledgers, and calibrated wording.',
    readingTime: 23,
  },
  'ai-content-operations-workflow': {
    url: '/blog/ai-content-operations-workflow/',
    title: 'AI Content Operations Workflow: Brief, Draft, Review, Repurpose',
    excerpt:
      'AI content ops should increase accepted, useful content - not text waiting for review. The scaling constraint is claim and approval throughput, not token generation.',
    readingTime: 24,
  },
  'ai-sdr-to-human-handoff': {
    url: '/blog/ai-sdr-to-human-handoff/',
    title: 'AI SDR to Human Handoff: When a Lead Becomes Sales-Ready',
    excerpt:
      'A useful handoff is an acceptance contract between prospecting and sales, not a notification. Four gates - fit, contact, engagement, intent - and none substitutes for another.',
    readingTime: 23,
  },
  'ai-customer-support-escalation': {
    url: '/blog/ai-customer-support-escalation/',
    title: 'AI Customer Support Escalation: When the Agent Should Stop',
    excerpt:
      'Escalate when unsure is not an operating rule. Explicit stop triggers, a context packet that travels with the case, and a receiver who formally accepts.',
    readingTime: 24,
  },
  /* ---- Product Updates (flagship changelog posts, added 2026-08-03 CEL-841):
     the three stories that carry the company narrative — the AI-employee launch,
     the Fable 5 foundation, and the built-with-itself Cowork proof. ---- */
  'meet-your-ai-employee': {
    url: '/blog/meet-your-ai-employee/',
    title: 'Meet Your AI Employee: Hire a Role, Not a Tool',
    excerpt:
      'The biggest thing we\u2019ve ever built: a general-purpose AI worker you hire for a role, with its own identity, inbox, channels, task board, and a memory that carries between working sessions.',
    readingTime: 7,
  },
  'cellcog-runs-on-fable-5': {
    url: '/blog/cellcog-runs-on-fable-5/',
    title: 'CellCog Runs on Fable 5: The Model That Makes AI Employees Possible',
    excerpt:
      'Every chat on CellCog now runs on Fable 5, Anthropic\u2019s Mythos-class frontier model - and why AI employees were not truly possible before it.',
    readingTime: 9,
  },
  'we-built-cellcog-with-cellcog': {
    url: '/blog/we-built-cellcog-with-cellcog/',
    title: 'We Built CellCog With CellCog. Now You Can Too: Cowork Is Live',
    excerpt:
      'For months, every line of CellCog has been written by CellCog agents working on our machines through Cowork. Today that power ships to every user.',
    readingTime: 6,
  },
  'ai-kpi-reporting-workflow': {
    url: '/blog/ai-kpi-reporting-workflow/',
    title: 'AI KPI Reporting Workflow: From Data to Exceptions and Actions',
    excerpt:
      'Useful only when a reviewer can reproduce the number, understand the variance, accept the explanation, and assign an action. A polished dashboard can still be wrong.',
    readingTime: 25,
  },
  /* ---- Fresh-signal engine posts (added 2026-08-16): monthly harness ranking
     flagship + the GLM 5.3 / Qwen3.8 launch-week cluster. ---- */
  'best-ai-agent-harnesses': {
    url: '/blog/best-ai-agent-harnesses/',
    title: 'Best AI Agent Harnesses: October 2026 Rankings',
    excerpt:
      'Six agent harnesses re-ranked for October 2026 after Opus 5.5, GPT-6.1 Sol and Gemini 4 Argon, CellCog included and receipted, plus the runtime and employee layers rankings ignore.',
    readingTime: 7,
  },
  'ai-employee-contacts': {
    url: '/blog/ai-employee-contacts/',
    title: 'Your AI Employees Now Share One Contacts Book',
    excerpt:
      'Contacts is live: one shared record of every person your AI employees email, call or meet, with who vouched for them, their notes and every touch.',
    readingTime: 6,
  },
  'best-ai-receptionists': {
    url: '/blog/best-ai-receptionists/',
    title: 'Best AI Receptionists for Small Business: 12 Ranked',
    excerpt:
      'Twelve AI receptionists for small business ranked on calls, bookings and follow-up, with prices read off each vendor pricing page, CellCog included.',
    readingTime: 10,
  },
  'best-ai-executive-assistants': {
    url: '/blog/best-ai-executive-assistants/',
    title: 'Best AI Executive Assistants: 13 Ranked, Prices Checked',
    excerpt:
      'Thirteen AI executive assistants ranked for inbox, calendar, meetings and calls, with prices read off each vendor pricing page, CellCog included.',
    readingTime: 11,
  },
  'best-super-agents': {
    url: '/blog/best-super-agents/',
    title: 'Best Super Agents, Ranked With Receipts',
    excerpt:
      'Eight general-purpose AI agents that turn one instruction into finished work, ranked for October 2026 with prices read off each vendor pricing page.',
    readingTime: 9,
  },
  'glm-5-3-vs-qwen3-8-max': {
    url: '/blog/glm-5-3-vs-qwen3-8-max/',
    title: 'GLM 5.3 vs Qwen3.8-Max: The Open-Weight Frontier, Compared (August 2026)',
    excerpt:
      'Two open-weight frontier models landed in one week. A source-grounded comparison of GLM 5.3 and Qwen3.8-Max: benchmarks, licensing, pricing, and agentic fit.',
    readingTime: 5,
  },
  'glm-5-3-for-ai-agents': {
    url: '/blog/glm-5-3-for-ai-agents/',
    title: 'GLM 5.3 for AI Agents: Release Date, Weights, What It Means',
    excerpt:
      'Z.ai\u2019s GLM 5.3 posts the strongest open-weight agentic numbers yet, and its delayed weights carry a lesson about agents, capability, and permissions.',
    readingTime: 6,
  },
  /* ---- Cursor Origin launch cluster (added 2026-08-19): fresh-signal
     land-grab on Cursor's Git forge launch (Aug 17). ---- */
  'cursor-origin-pricing': {
    url: '/blog/cursor-origin-pricing/',
    title: 'Cursor Origin Pricing: What It Actually Costs in 2026',
    excerpt:
      'Origin has no price of its own: bundled with paid Cursor plans during beta, no published limits, no committed post-beta price. The full breakdown.',
    readingTime: 6,
  },
  'what-is-cursor-origin': {
    url: '/blog/what-is-cursor-origin/',
    title: 'What Is Cursor Origin? Git for Agents vs GitHub',
    excerpt:
      'A source-grounded explainer of Cursor Origin: what shipped in the beta, how GitHub mirroring works, agent integration, and the honest limitations.',
    readingTime: 6,
  },
  /* ---- Fable 5.1 rumor tracker (added 2026-08-19): living page, updated
     same-day when the model becomes real. ---- */
  'fable-5-1-release-date': {
    url: '/blog/fable-5-1-release-date/',
    title: 'Fable 5.1 Is Out: Pricing, Benchmarks, and What Actually Changed',
    excerpt:
      'Fable 5.1 shipped September 1, 2026: pricing held at $10/$50, cache reads fell 75%, 1M context. The confirmed record plus the rumor scorecard, from Fable-line operators.',
    readingTime: 7,
  },
  /* ---- Sep 1 late batch (added 2026-09-01): Grok Bot model lock-in argument +
     Astra vs Fable 5.1 living comparison. ---- */
  'grok-bot-lock-in': {
    url: '/blog/grok-bot-lock-in/',
    title: 'Grok Bot Can\u2019t Run Fable 5.1: The Application-Layer Case',
    excerpt:
      'Anthropic shipped Fable 5.1 on September 1, 2026, and CellCog\u2019s Agent Max and Team Max ran it that afternoon. Grok Bot has no model picker, by design. That is the argument for the application layer.',
    readingTime: 8,
  },
  'astra-vs-fable-5-1': {
    url: '/blog/astra-vs-fable-5-1/',
    title: 'GPT-6 Astra vs Claude Fable 5.1: Price, Cache, Head-to-Head',
    excerpt:
      'OpenAI launched GPT-6 Astra two days after Anthropic shipped Claude Fable 5.1, at the same $10 and $50 per million tokens. What differs: access, cache pricing, safety posture and evidence.',
    readingTime: 9,
  },
  /* ---- Fresh-signal (added 2026-09-02): Qwen3.8-Max-0902 in-place upgrade. ---- */
  'qwen3-8-max-0902': {
    url: '/blog/qwen3-8-max-0902/',
    title: 'Qwen3.8-Max-0902: Same Price, Much Better at Coding and Office Work, Still Behind Opus 5',
    excerpt:
      'Alibaba upgraded Qwen3.8-Max in place on September 1, 2026. Same price, same 1M context, sharply better coding and office-work scores. What changed, what it costs, and where Claude Opus 5 still leads.',
    readingTime: 9,
  },
  /* ---- Product update (added 2026-09-01, corrected 2026-09-02): Agent core/max + Team
     core/max moved to Fable 5.1 on Anthropic's release day. ---- */
  'cellcog-opus-5-5-day-one': {
    url: '/blog/cellcog-opus-5-5-day-one/',
    title: 'Every Agent Tier Now Runs on Claude Opus 5.5, Day One',
    excerpt:
      'Anthropic released Claude Opus 5.5 on September 22, 2026. The same day, every CellCog tier that ran Claude Fable 5.1 moved to it: Agent, Creative and Team, Core and Max. Flash is unchanged.',
    readingTime: 7,
  },
  'cellcog-fable-5-1-day-one': {
    url: '/blog/cellcog-fable-5-1-day-one/',
    title: 'Agent and Team Tiers Now Run on Fable 5.1, the Day Anthropic Shipped It',
    excerpt:
      'Anthropic released Claude Fable 5.1 on September 1, 2026. The same day, CellCog\u2019s Agent and Team tiers, Core and Max, moved to it. Creative and Flash are unchanged. Nothing to change on your side.',
    readingTime: 5,
  },
  /* ---- Fresh-signal (added 2026-09-02): Gemini 3.8 Flash + Flash Cyber launch record. ---- */
  'gemini-3-8-flash': {
    url: '/blog/gemini-3-8-flash/',
    title: 'Gemini 3.8 Flash vs 3.7: Benchmarks, Price, Cyber Variant',
    excerpt:
      'Google released Gemini 3.8 Flash on September 2, 2026: same $0.75/$3.75 intro price as 3.7 Flash, an 8-point DeepSWE jump to within 0.3 of Claude Opus 5, and a cyber variant for defenders.',
    readingTime: 10,
  },
  /* ---- Product update (added 2026-09-02): Flash tiers moved to Gemini 3.8 Flash on
     Google's release day. ---- */
  'cellcog-smart-routing-gemini-3-8-flash': {
    url: '/blog/cellcog-smart-routing-gemini-3-8-flash/',
    title: 'Flash Tiers Now Run on Gemini 3.8 Flash, the Day Google Shipped It',
    excerpt:
      'Google released Gemini 3.8 Flash on September 2, 2026. The same day, CellCog\u2019s Flash tiers moved to it: same setting, same pricing, better agent scores. Nothing to change on your side.',
    readingTime: 5,
  },
  /* ---- Fresh-signal (added 2026-09-03): Meta's Muse Spark 1.3 release, read against
     Meta's own table + the Artificial Analysis index. ---- */
  'muse-spark-1-3': {
    url: '/blog/muse-spark-1-3/',
    title: 'Muse Spark 1.3 Is Out: Meta Claims Frontier Parity, and Its Own Table Mostly Backs It',
    excerpt:
      'Meta released Muse Spark 1.3 on September 2, 2026: level with Claude Opus 5 on agentic work by Meta\u2019s own table, ahead on long context, at $1.25/$4.25. The max mode in the table is not public yet.',
    readingTime: 10,
  },
  /* ---- Fresh-signal (added 2026-09-03, Nitish's ask): MiniMax H3 Max, faster-than-realtime
     video as the unlock for AI employees getting a face. ---- */
  'minimax-h3-max': {
    url: '/blog/minimax-h3-max/',
    title: 'MiniMax H3 Max Renders Video Faster Than It Plays. That Is How AI Employees Get a Face.',
    excerpt:
      'fal\u2019s MiniMax H3 Max post-train renders 5 seconds of video in under 3 seconds and tops two leaderboards at $0.08 a second. Once generation outruns playback, an employee can have a face that answers.',
    readingTime: 9,
  },
  /* ---- Fresh-signal cluster (added 2026-08-27): OpenAI/HF incident explainer,
     Grok Bot Aug-26 plan expansion, Perplexity Portable Computer launch. ---- */
  'claude-cybersecurity-incidents': {
    url: '/blog/claude-cybersecurity-incidents/',
    title: 'Four Times Claude Left the Sandbox: Anthropic\'s Alignment Assessment, Explained',
    excerpt:
      'Four incidents: models that talked themselves into thinking the real internet was a simulation. Anthropic\'s numbers, the layers that would have caught it, and what it means for agents on real systems.',
    readingTime: 11,
  },
  'openai-hugging-face-incident': {
    url: '/blog/openai-hugging-face-incident/',
    title: 'OpenAI Hugging Face Incident: What Happened and Changed',
    excerpt:
      'OpenAI\u2019s August 26 report, explained: eval agents built a message board, escaped their sandboxes, and breached Hugging Face - and safeguards cut the behavior 100x.',
    readingTime: 8,
  },
  'grok-bot-cursor-pro': {
    url: '/blog/grok-bot-cursor-pro/',
    title: 'Grok Bot Comes to Cursor Pro: The $20 Route, Explained',
    excerpt:
      'SpaceXAI dropped Grok Bot\u2019s entry price for the second time in five days: base Cursor Pro at $20 now includes it. The eight routes and the honest math.',
    readingTime: 6,
  },
  'perplexity-portable-computer': {
    url: '/blog/perplexity-portable-computer/',
    title: 'Perplexity Portable Computer: Local-First Agents, Explained',
    excerpt:
      'Perplexity\u2019s new Portable Computer runs its agent entirely on device: what hardware it needs, what stays local, what escalates to the cloud, and the real cost.',
    readingTime: 6,
  },
  /* ---- Fresh-signal pair (added 2026-08-28): Codex Persistent mode tracker
     (WIRED Aug 27) + Cursor Cloud Agents start-from-scratch (changelog Aug 27). ---- */
  'codex-persistent-mode': {
    url: '/blog/codex-persistent-mode/',
    title: "Codex Persistent Mode: OpenAI's Always-On Agent, What We Actually Know",
    excerpt:
      'OpenAI confirmed it is testing an always-on Codex that creates its own follow-up tasks and works until put to sleep. What the code shows, and what is unreleased.',
    readingTime: 7,
  },
  'cursor-start-from-scratch': {
    url: '/blog/cursor-start-from-scratch/',
    title: 'Cursor Cloud Agents Without a Repo: How It Works',
    excerpt:
      'Cursor removed the repo requirement from Cloud Agents on August 27: prompt first, get an Origin repo, live browser preview, and Vercel publish. What it means.',
    readingTime: 6,
  },
  /* ---- Instinct land-grab pair (added 2026-08-27): the viral invite-only
     personal agent ($2.5B Series B Aug 26). Explainer + alternatives. ---- */

  'what-is-instinct-ai': {
    url: '/blog/what-is-instinct-ai/',
    title: 'What Is Instinct AI? The Viral Personal Assistant, Explained',
    excerpt:
      'A source-grounded explainer of Instinct, the invite-only personal AI agent: what it actually does, the $2.5B valuation, and what its own terms say about your data.',
    readingTime: 7,
  },
  'instinct-ai-alternatives': {
    url: '/blog/instinct-ai-alternatives/',
    title: 'Instinct AI Alternatives You Can Use Today (No Invite Needed)',
    excerpt:
      'Instinct is invite-only and the waitlist is long. Seven delegated-AI alternatives you can actually use today, ranked, with dated receipts and honest caveats.',
    readingTime: 7,
  },
  /* ---- Fresh-signal pair (added 2026-08-28 pm): Claudeforce explainer
     (Salesforce-Anthropic, Aug 26) + Uber software factory numbers (Aug 27). ---- */
  'what-is-claudeforce': {
    url: '/blog/what-is-claudeforce/',
    title: 'What Is Claudeforce? Salesforce\'s Claude Agent, Explained',
    excerpt:
      'A source-grounded explainer of Claudeforce: what Salesforce and Anthropic actually announced on August 26, what ships now versus September, and what it validates.',
    readingTime: 7,
  },
  'uber-software-factory': {
    url: '/blog/uber-software-factory/',
    title: "Uber's AI Software Factory: 70% of Pull Requests, 3,600 Agent Skills, Flat Spend",
    excerpt:
      'Uber published the most concrete enterprise-agent numbers yet: 70%+ of PRs agent-attributed, 9.4x request growth on flat spend. The playbook and the caveats.',
    readingTime: 7,
  },
  /* ---- Product update (added 2026-08-31): custom MCP servers ship. ---- */
  'connect-your-own-mcp-servers': {
    url: '/blog/connect-your-own-mcp-servers/',
    title: 'Connect Your Own MCP Servers: Bring Any Tool to Your CellCog Agents',
    excerpt:
      "Paste an MCP server's URL and your agents can discover and call its tools - internal company tools included - behind the same approvals as everything else.",
    readingTime: 6,
  },
  'ai-employee-routines': {
    url: '/blog/ai-employee-routines/',
    title: 'Routines: Schedule an Organization of AI Employees, Not One Bot at a Time',
    excerpt:
      'A routine is a named time trigger with a standing brief. It wakes one employee, a whole team or a workstream, and the new Routines page shows every scheduled wake in your organization at once.',
    readingTime: 10,
  },
  'ai-employees-have-phone-numbers': {
    url: '/blog/ai-employees-have-phone-numbers/',
    title: 'Your AI Employees Now Have Phone Numbers',
    excerpt:
      'Ask your AI employee for a phone number and it has one within moments. People call it and talk to the employee; it calls applicants, customers and partners who expect it, under your business.',
    readingTime: 10,
  },
  'ai-employees-attend-meetings': {
    url: '/blog/ai-employees-attend-meetings/',
    title: 'AI Employees Now Attend Google Meet and Zoom Calls',
    excerpt:
      'Invite an AI employee to a meeting. It accepts, prepares, joins camera-off under its own name, answers what it is authorized to say, never commits in the room, and files the notes after.',
    readingTime: 8,
  },
  'casa-security-assessment': {
    url: '/blog/casa-security-assessment/',
    title: "CellCog Completes Google's CASA Security Assessment",
    excerpt:
      "Google approved CellCog's OAuth app for Gmail and Google Analytics in September 2026 after a CASA Tier 2 assessment by an authorized lab. What changed, what we do not claim.",
    readingTime: 6,
  },
  'github-copilot-runtime-rust-rewrite': {
    url: '/blog/github-copilot-runtime-rust-rewrite/',
    title: 'GitHub Rewrote Copilot in Rust: 800k Lines, One Developer',
    excerpt:
      "GitHub published the receipts for rewriting its Copilot agent runtime from TypeScript into 832,378 lines of Rust: one developer, 128 pull requests, 14.5 weeks, about $120,000 in tokens.",
    readingTime: 9,
  },
  'nous-hermes-1393-agents-refactor': {
    url: '/blog/nous-hermes-1393-agents-refactor/',
    title: 'Nous Research Cut 1M Lines of Code With 1,393 Agents',
    excerpt:
      "On September 2, Teknium asked Hermes Agent to clean up a million-line repo. 1,393 subagents and 19 hours later the code was 34.4% smaller, for about $19,300. What the run showed and what it did not.",
    readingTime: 8,
  },
  'dream-rsi-recursive-self-improvement': {
    url: '/blog/dream-rsi-recursive-self-improvement/',
    title: 'Dream-RSI: Google Agents Self-Improve, Weights Stay Fixed',
    excerpt: "A Google paper where the agent improves how it searches, not what it is. The claims, their baselines, and why it reads like the harness half of recursion.",
    readingTime: 8,
  },
  'what-is-union-alpha': {
    url: '/blog/what-is-union-alpha/',
    title: "Union Alpha Revealed: Pareto by Unbiased, at $2.50/$7.50",
    excerpt: "OpenRouter named its stealth model 33 hours after listing it: Pareto, a blended model from Unbiased (Circuit & Chisel), now $2.50 in and $7.50 out per million tokens. The launch claims, scored.",
    readingTime: 9,
  },
  'openai-misalignment-reporting-framework': {
    url: '/blog/openai-misalignment-reporting-framework/',
    title: "OpenAI's Misalignment Reports: Nine Incidents, One Framework",
    excerpt: "OpenAI's disclosure framework and nine reports from its own runs: a self-written jailbreak, hidden mistakes, a researcher's GitHub token leaked in public, and a self-replicating injection.",
    readingTime: 12,
  },
  'lyria-3-5': {
    url: '/blog/lyria-3-5/',
    title: 'Lyria 3.5 Is in the Gemini API: $0.08 a Song, 44.1 kHz, and What It Means for AI-Made Video',
    excerpt:
      "Lyria 3.5, Google's music model, is now in the Gemini app and API at $0.08 per full song, 44.1 kHz stereo, with vocals and timed lyrics. What the docs say, what they don't, and how it stacks up.",
    readingTime: 6,
  },
  /* ---- Registry backfill (2026-08-31, Nitish's ask): every product-update
     post + two missed evergreen posts, so ALL live posts are linkable from
     marketing pages and FurtherReading strips. Generated from post frontmatter. ---- */
  "3d-model-generation": {
    url: "/blog/3d-model-generation/",
    title: "Ideas In. 3D Models Out. Production-Ready GLB Generation Is Here",
    excerpt:
      "Text descriptions, reference images, rough sketches, or a list of 20 items in one prompt - CellCog now turns them into textured, game-ready GLB models.",
    readingTime: 3,
  },
  "adaptive-image-routing-gpt-image-2": {
    url: "/blog/adaptive-image-routing-gpt-image-2/",
    title: "Adaptive Image Routing: GPT Image 2 Is Live on CellCog",
    excerpt:
      "Three dedicated image engines, one agent that picks the right one for each request - with GPT Image 2 joining as the new flagship for text rendering and photorealism.",
    readingTime: 3,
  },
  "agent-computer": {
    url: "/blog/agent-computer/",
    title: "Agent Computer: Understand How Your AI Thinks and Works",
    excerpt:
      "Ever wondered what your AI is actually doing behind the scenes? Agent Computer lets you browse your agent's workspace and watch files appear as it works.",
    readingTime: 3,
  },
  "agent-team-max-gpt-5-6-sol-search": {
    url: "/blog/agent-team-max-gpt-5-6-sol-search/",
    title: "Agent Team Max Web Search Now Runs on GPT-5.6 Sol",
    excerpt:
      "The web-search engine inside Agent Team Max moved from GPT-5.5 to GPT-5.6 Sol, OpenAI's flagship reasoning model, at the same price as before.",
    readingTime: 3,
  },
  "agent-team-max": {
    url: "/blog/agent-team-max/",
    title: "Introducing Agent Team Max: For High-Stakes Work",
    excerpt:
      "A new mode where every setting is turned to the max: deeper search and higher reasoning depth, aimed at the last percentage points of quality for high-stakes work.",
    readingTime: 3,
  },
  "ai-docs-any-document-one-prompt": {
    url: "/blog/ai-docs-any-document-one-prompt/",
    title: "AI Docs: Any Document, One Prompt",
    excerpt:
      "Create professional documents in seconds - resumes to restaurant menus, invoices to certificates - from a single prompt, with template upload to match your style.",
    readingTime: 3,
  },
  "any-agent-can-now-use-cellcog": {
    url: "/blog/any-agent-can-now-use-cellcog/",
    title: "Any Agent Can Now Use CellCog, Not Just OpenClaw",
    excerpt:
      "SDK v2.0 opens CellCog to the whole agent ecosystem: any agent with Python in its environment can now delegate research, video, documents, and dashboards to CellCog.",
    readingTime: 3,
  },
  "avatars-your-characters-everywhere": {
    url: "/blog/avatars-your-characters-everywhere/",
    title: "Avatars: Your Characters, Your Voice, Everywhere",
    excerpt:
      "Create once, use everywhere: digital personas with your face, your voice, and your style that stay consistent across all your CellCog chats and content.",
    readingTime: 3,
  },
  "cellcog-1-deep-research-bench-jan-2026": {
    url: "/blog/cellcog-1-deep-research-bench-jan-2026/",
    title: "CellCog Returns to Global #1 on Deep Research Bench (January 2026)",
    excerpt:
      "Months of stack-wide improvements - tools, search, reasoning - put CellCog back at #1 globally on Deep Research Bench, led by a +3.76 jump in Insight.",
    readingTime: 3,
  },
  "cellcog-browse-chrome-extension": {
    url: "/blog/cellcog-browse-chrome-extension/",
    title: "CellCog Browse: Your AI, in Your Chrome",
    excerpt:
      "The Chrome extension that lets your AI agent work in your real browser: your logins, your tabs, your sessions - with every action classified before it runs.",
    readingTime: 3,
  },
  "cellcog-plugin-linear-agent": {
    url: "/blog/cellcog-plugin-linear-agent/",
    title: "Introducing the CellCog Plugin and the Linear Agent",
    excerpt:
      "Two launches: a plugin that brings CellCog's multimodal execution into your coding editor, and the first multimodal execution agent in Linear's integration directory.",
    readingTime: 3,
  },
  "cellcog-smart-routing-gemini-3-7-flash": {
    url: "/blog/cellcog-smart-routing-gemini-3-7-flash/",
    title: "Gemini 3.7 Flash Joins CellCog's Smart Routing, the Day Google Shipped It",
    excerpt:
      "CellCog's smart routing upgraded its fast lane to Gemini 3.7 Flash the day Google released it - newer model, lower cost, zero action needed on your side.",
    readingTime: 3,
  },
  "code-cog-agent-core": {
    url: "/blog/code-cog-agent-core/",
    title: "Code Cog and Agent Core: The First Coding Agent Built for Agents",
    excerpt:
      "Cursor, Claude Code, and Codex are built for humans. Code Cog and Agent Core are CellCog's answer to a different question: what happens when your AGENT needs to code?",
    readingTime: 3,
  },
  "connected-chats": {
    url: "/blog/connected-chats/",
    title: "Connected Chats: Your AI Agents Now Work Together Across Conversations",
    excerpt:
      "Ask one chat to edit a PDF or app created by another - they find each other through embedded metadata, link workspaces, and work together automatically.",
    readingTime: 3,
  },
  "employee-computer": {
    url: "/blog/employee-computer/",
    title: "Your AI Employee Now Has Its Own Computer",
    excerpt:
      "Your AI employee's world is now a computer you can open: real windows, a dock, Mail and Tasks and Approvals as apps, files opening side by side, and its own dashboards with icons. No pixel streaming.",
    readingTime: 4,
  },
  "every-tool-one-approval-rail": {
    url: "/blog/every-tool-one-approval-rail/",
    title: "Every Tool You Use: 20,000+ Actions, One Approval Rail",
    excerpt:
      "Agents can now discover the right action across 1,500+ apps by describing what they want to do - and every action is threat-classified and summarized before it runs.",
    readingTime: 3,
  },
  "flash-core-max": {
    url: "/blog/flash-core-max/",
    title: "CellCog Flash: 20x Cheaper, 3x Faster - and Every Agent Gets Tiers",
    excerpt:
      "Every CellCog chat now runs on an agent and tier pair. Flash is the new speed point: about 20x cheaper and 3x faster than Max in our tests. Here is the whole grid, and how switching works.",
    readingTime: 5,
  },
  "grok-bot-pricing": {
    url: "/blog/grok-bot-pricing/",
    title: "Grok Bot Pricing Explained: What It Actually Costs",
    excerpt:
      "Grok Bot has no standalone price, and the entry just dropped again to $20. A clear breakdown of the eight subscription routes, weekly allowances, on-demand billing, and how the total compares.",
    readingTime: 11,
  },
  "non-zero-sum-cold-outreach": {
    url: "/blog/non-zero-sum-cold-outreach/",
    title: "Non-Zero-Sum Cold Outreach: Every Email Should Win for Both Sides",
    excerpt:
      "Cold outreach usually burns reputation. Your AI employee now runs the whole motion, and tests every email first: would this person be genuinely glad you reached out?",
    readingTime: 3,
  },
  "openclaw-2-0": {
    url: "/blog/openclaw-2-0/",
    title: "OpenClaw 2.0: What's New, What Breaks, What It Signals",
    excerpt:
      "OpenClaw's largest release ever: 16,000+ pull requests from 933 contributors. Guided setup, multiplayer sessions, built-in memory, the reworked security model, and the three migrations to plan for.",
    readingTime: 8,
  },
  "openclaw-cellcog-real-deliverables": {
    url: "/blog/openclaw-cellcog-real-deliverables/",
    title: "The Agent Evolution: OpenClaw + CellCog = Real Deliverables",
    excerpt:
      "CellCog becomes the execution layer for OpenClaw agents: they orchestrate the conversation, CellCog handles research, video, images, PDFs, and dashboards.",
    readingTime: 3,
  },
  "openclaw-security": {
    url: "/blog/openclaw-security/",
    title: "OpenClaw Security in 2026: What July's Advisories Mean If You Run Agents",
    excerpt:
      "July was OpenClaw's biggest security month: 14 advisories in one day, a major hardening release, and new supply-chain research. What to check, what to harden, and where the responsibility line sits.",
    readingTime: 6,
  },
  "podcasts-and-memes-one-prompt": {
    url: "/blog/podcasts-and-memes-one-prompt/",
    title: "Podcasts and Memes. One Prompt.",
    excerpt:
      "Two new frontiers in one release: full podcast production with multi-voice dialogue and intro music, and AI meme generation with ruthless quality curation.",
    readingTime: 3,
  },
  "project-cog-context-trees": {
    url: "/blog/project-cog-context-trees/",
    title: "Documents In. Intelligence Out. Project Cog Brings Context Trees to Every Agent",
    excerpt:
      "Upload any documents, get a hierarchical Context Tree with structured summaries - the same memory structures that power CellCog's internal agents, now open to yours.",
    readingTime: 3,
  },
  "real-time-agent-collaboration": {
    url: "/blog/real-time-agent-collaboration/",
    title: "Real-Time Agent Collaboration Is Here: Message While They Work",
    excerpt:
      "Forgot to mention something? Keep going. Messages now flow while agents work - queued smartly, delivered at the right moment, no more waiting for responses to finish.",
    readingTime: 3,
  },
  "role-immersion": {
    url: "/blog/role-immersion/",
    title: "Role Immersion: Every Prompt Now Starts With the Right Experts",
    excerpt:
      "A new foundational reasoning step: before any work begins, the agent assembles the expert roles your prompt deserves, appoints a reviewer, and commits to a quality bar.",
    readingTime: 3,
  },
  "seedance-2-5-full-films-one-prompt": {
    url: "/blog/seedance-2-5-full-films-one-prompt/",
    title: "Full Films From One Prompt: Seedance 2.5 Powers CellCog Video",
    excerpt:
      "The engine under CellCog's film production just got stronger: Seedance 2.5 brings longer takes and 50 reference files, so multi-minute single-prompt films hold together better than ever.",
    readingTime: 3,
  },
  "seedance-2-next-level-ai-video": {
    url: "/blog/seedance-2-next-level-ai-video/",
    title: "Lights, Camera, Seedance 2.0: Next-Level AI Video Is Live",
    excerpt:
      "ByteDance's most advanced video generation model lands on CellCog: higher cinematic quality, 15-second segments, native audio, and director-level camera control.",
    readingTime: 3,
  },
  "seedance-2-unrestricted-access": {
    url: "/blog/seedance-2-unrestricted-access/",
    title: "Seedance 2.0 Unrestricted: Global Access for Businesses and Individuals",
    excerpt:
      "Two days after launch, the gates come off: Seedance 2.0 becomes the default video model on CellCog for every user worldwide - no eligibility checks, no region locks.",
    readingTime: 3,
  },
  "text-to-music-generation": {
    url: "/blog/text-to-music-generation/",
    title: "CellCog Goes Musical: Text-to-Music Generation Is Here",
    excerpt:
      "Describe the mood, tempo, instruments, and genre - get a unique audio track in seconds. From 3-second stingers to 10-minute compositions.",
    readingTime: 3,
  },
  "time-to-first-token-70-percent-faster": {
    url: "/blog/time-to-first-token-70-percent-faster/",
    title: "From 15s to 4.5s: How We Made Time to First Token 70% Faster",
    excerpt:
      "Agent startup time dropped from 15 seconds to 4.5 - fast enough that a full agent can now replace your LLM chat for everyday tasks.",
    readingTime: 3,
  },
  "vector-images-icon-generation": {
    url: "/blog/vector-images-icon-generation/",
    title: "Introducing Vector Images and Icon Generation: Infinitely Scalable SVGs",
    excerpt:
      "Two new creative modalities produce infinitely scalable SVG graphics: vector illustrations for marketing and web, and icons for apps, logos, and UI.",
    readingTime: 3,
  },
  "video-suite-v3": {
    url: "/blog/video-suite-v3/",
    title: "Video Suite v3: Precision Tools for Unrestricted Storytelling",
    excerpt:
      "The philosophy shift: from 'AI improvises your idea' to 'AI executes your vision with professional precision' - plus 3x longer lipsync and half the cost.",
    readingTime: 3,
  },
  'best-ai-sdr-tools': {
    url: "/blog/best-ai-sdr-tools/",
    title: "Best AI SDR Tools: 9 Ranked for Small Teams",
    excerpt:
      "Nine AI SDR tools ranked on what happens before the first send: research, writing, follow-up. Live prices, three kinds of tool, and where CellCog wins and loses.",
    readingTime: 8,
  },
  'best-ai-social-media-managers': {
    url: "/blog/best-ai-social-media-managers/",
    title: "Best AI Social Media Managers: 9 Ranked",
    excerpt:
      "Nine AI social media tools ranked on how much of the job they own: planning, writing, visuals and posting. Live prices, four kinds of tool, and where CellCog wins and loses.",
    readingTime: 7,
  },
  'best-ai-recruiters': {
    url: "/blog/best-ai-recruiters/",
    title: "Best AI Recruiters: 9 Ranked",
    excerpt:
      "Nine AI recruiting tools ranked on how much of the hiring work they own: sourcing, screening, outreach and scheduling. Live prices, four kinds of tool, and where CellCog loses.",
    readingTime: 7,
  },
  'best-ai-data-analysts': {
    url: "/blog/best-ai-data-analysts/",
    title: "Best AI Data Analysts: 8 Tools Ranked",
    excerpt:
      "Eight AI data analyst tools ranked on how much of the analyst's job they take off a small team: queries, dashboards and the weekly read. Live prices, three kinds of tool, and where CellCog loses.",
    readingTime: 7,
  },
  'best-ai-content-creators': {
    url: "/blog/best-ai-content-creators/",
    title: "Best AI Content Creators: 8 Tools Ranked",
    excerpt:
      "Eight AI content creator tools ranked on how much of the production they take off a small business: videos, graphics, episodes and posts. Live prices, three kinds of tool, and where CellCog loses.",
    readingTime: 7,
  },
  'best-ai-project-management-tools': {
    url: "/blog/best-ai-project-management-tools/",
    title: "Best AI Project Management Tools: 9 Ranked",
    excerpt:
      "Nine AI project management tools ranked on how much of the project manager's job they take off a small team: plan, standup, tracker and status. Live prices and where CellCog loses.",
    readingTime: 8,
  },
  'best-ai-bookkeeping-software': {
    url: "/blog/best-ai-bookkeeping-software/",
    title: "Best AI Bookkeeping Software: 9 Tools Ranked",
    excerpt:
      "Nine AI bookkeeping tools ranked on how much of the work they take off a small business: categorizing, reconciling, invoices and the close. Live prices and where CellCog loses.",
    readingTime: 8,
  },
};

/** Default reading set for ROLE pages: the three category-basics posts are
 *  relevant to hiring ANY role, so every role page links all three unless a
 *  config overrides with its own `relatedPosts` list. */
export const DEFAULT_ROLE_READING = [
  'what-is-an-ai-employee',
  'how-to-hire-an-ai-employee',
  'ai-employee-cost',
  'meet-your-ai-employee',
];
